module.exports = __webpack_public_path__ + "img/128-190.14789639.jpg";